export default __webpack_public_path__ + "static/media/flag-micronesia.b5f850e6.svg";